import React from "react"
import { createRoot } from "react-dom/client"
import PhoneLogin from "@components/PhoneLogin"

document.addEventListener("DOMContentLoaded", () => {
  const containerElement = document.getElementById("render-phone-login")
  // console.log('phone-login containerElement', containerElement)
  if (!containerElement) {
    return false
  }
  // debugger;
  const dataset = JSON.parse(containerElement.dataset.data)

  const root = createRoot(containerElement)
  root.render(<PhoneLogin action={dataset.action} />)
})
